import { matchesValue, selectGloboOption } from './stick-fit-prefill.js';

const STYLES = `
  .grip-advanced {
    display: block;
    margin-top: 8px;
  }
  .grip-advanced__options {
    display: block;
    margin-top: 8px;
  }
  .grip-advanced summary {
    cursor: pointer;
    color: var(--hlc-muted);
    font-size: 0.85em;
    list-style: none;
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
  .grip-advanced summary::-webkit-details-marker { display: none; }
  .grip-advanced summary::after {
    content: '';
    border: solid var(--hlc-muted);
    border-width: 0 1.5px 1.5px 0;
    padding: 2.5px;
    transform: rotate(-45deg);
    transition: transform 0.2s;
  }
  .grip-advanced[open] summary::after {
    transform: rotate(45deg);
  }
  .grip-advanced summary:hover {
    color: var(--hlc-muted-hover);
  }
  .grip-advanced summary:hover::after {
    border-color: var(--hlc-muted-hover);
  }
  @media (prefers-reduced-motion: reduce) {
    .grip-advanced summary::after { transition: none; }
  }
`;

function findGripWrapper() {
  const labels = document.querySelectorAll(
    'label, .globo-option-label, [data-option-label]',
  );

  for (const label of labels) {
    const text = label.textContent.trim().toLowerCase().replace(/[^a-z0-9]/g, '');
    if (!text.includes('grip')) continue;

    return label.closest(
      '.globo-option, .globo-product-option, [data-option-index], fieldset',
    ) || label.parentElement;
  }
  return null;
}

function isStandard(value) {
  return matchesValue(value, 'Standard');
}

function injectStyles() {
  if (document.getElementById('grip-default-styles')) return;
  const style = document.createElement('style');
  style.id = 'grip-default-styles';
  style.textContent = STYLES;
  document.head.appendChild(style);
}

export function applyGripDefault() {
  const wrapper = findGripWrapper();
  if (!wrapper) return;

  injectStyles();

  const inputs = wrapper.querySelectorAll('input[type="radio"]');
  const alreadyChecked = Array.from(inputs).some((input) => input.checked);

  if (!alreadyChecked) {
    selectGloboOption('Grip Type', 'Standard');
  }

  const nonStandard = Array.from(inputs).filter(
    (input) => !isStandard(input.value),
  );
  if (nonStandard.length === 0) return;

  const details = document.createElement('details');
  details.className = 'grip-advanced';

  const summary = document.createElement('summary');
  summary.textContent = 'Advanced Grips';
  details.appendChild(summary);

  const optionsContainer = document.createElement('div');
  optionsContainer.className = 'grip-advanced__options';
  details.appendChild(optionsContainer);

  const firstNonStandard = nonStandard[0].closest(
    '.globo-option-value, .globo-swatch, [data-option-value]',
  ) || nonStandard[0].parentElement;
  firstNonStandard.before(details);

  for (const input of nonStandard) {
    const valueWrapper = input.closest(
      '.globo-option-value, .globo-swatch, [data-option-value]',
    ) || input.parentElement;
    optionsContainer.appendChild(valueWrapper);
  }
}

if (typeof window !== 'undefined') {
  document.addEventListener('gpoRenderCompleted', () => applyGripDefault());
}
